import { Controller } from "@hotwired/stimulus"
import L from "leaflet"

export default class extends Controller {

  static values = {
    latitude: Number,
    longitude: Number,
    markerIconUrl: String,
    markerIconRetinaUrl: String,
    markerShadowUrl: String
  }

  connect() {
    // Pas de double initialisation depuis l'aperçu Turbo (page cachée)
    if (document.documentElement.hasAttribute('data-turbo-preview')) {
      return
    }

    // Garde défensive : une carte existe déjà sur cette instance
    if (this.map) {
      return
    }

    // Nettoie toute instance Leaflet résiduelle sur cet élément DOM
    // (marqueurs orphelins d'une session précédente restaurée par Turbo)
    if (this.element._leaflet_id) {
      delete this.element._leaflet_id
    }
    this.element.innerHTML = ''

    this.map = L.map(this.element).setView([this.latitudeValue, this.longitudeValue], 13)

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap',
      maxZoom: 18
    }).addTo(this.map)

    // Vérification défensive: s'assurer que markerIconUrlValue est défini
    if (!this.markerIconUrlValue) {
      console.error('Leaflet controller: markerIconUrlValue is not defined. Check data-leaflet-marker-icon-url-value attribute.')
      return
    }

    // Définir l'icône personnalisée avec support Retina et ombre
    const icon = L.icon({
      iconUrl: this.markerIconUrlValue,
      iconRetinaUrl: this.markerIconRetinaUrlValue,
      shadowUrl: this.markerShadowUrlValue,
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    })

    this.marker = L.marker([this.latitudeValue, this.longitudeValue], { icon: icon }).addTo(this.map)
      .bindPopup("Mon Organisme de Formation")
      .openPopup()
  }

  disconnect() {
    // Clean up Leaflet map instance when controller disconnects
    if (this.marker) {
      this.marker.remove()
      this.marker = null
    }

    if (this.map) {
      // Remove all event listeners first
      this.map.off()
      // Then remove the map and its layers
      this.map.remove()
      this.map = null
    }

    // Clean up Leaflet's internal reference on the DOM element
    if (this.element._leaflet_id) {
      delete this.element._leaflet_id
    }
  }
}